<template>
	<b-modal
		ref="top-son-incidence-details"
		size="lg"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div>
					<h3 class="font-weight-bolder">{{ title }}</h3>
					<div>{{ totalSons }} hijos registrados con {{ totalIncidences }} incidencias</div>
				</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-row>
				<b-col>
					<b-card class="custom-card">
						<h4>Total Hijos</h4>
						<h2 class="font-weight-bolder">
							{{ totalSons }}
						</h2>
					</b-card>
				</b-col>
				<b-col>
					<b-card class="custom-card">
						<h4>Total Incidencias</h4>
						<h2 class="font-weight-bolder">
							{{ totalIncidences }}
						</h2>
					</b-card>
				</b-col>
				<b-col>
					<b-card class="custom-card">
						<h4>Promedio</h4>
						<h2 class="font-weight-bolder">
							{{ average }}
						</h2>
					</b-card>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="row.specimen" show_status />
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate :specimen="category_id == 1 ? row.madrilla : row.padrillo" />
							</b-td>
							<b-td class="text-center">
								<b-badge variant="info" class="incidence-badge">
									{{ row.total_incidences }}
								</b-badge>
							</b-td>
							<b-td class="text-center">
								<feather-icon
									@click="openIncidenceModal(row.specimen)"
									v-b-tooltip.hover="'Ver incidencias'"
									:class="{
										'icon-disabled': row.total_incidences == 0,
									}"
									class="text-primary"
									icon="EyeIcon"
									size="19"
									style="cursor: pointer"
								/>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<SpecimenIncidencesModal
			v-if="incidenceModal.show"
			:show="incidenceModal.show"
			:info="incidenceModal.info"
			@closing="incidenceModal.show = false"
		/>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import SpecimenService from "@/services/specimens.service.js"
import SpecimenIncidencesModal from "@/views/amg/videolibrary/incidences/IncidencesModal.vue"
export default {
	name: "TopSonIncidenceDetails",
	props: {
		category_id: {
			required: true,
		},
		specimen: {
			type: Object,
			required: true,
		},
	},
	components: {
		SpecimenPlate,
		SpecimenIncidencesModal,
	},
	data: () => ({
		isLoading: false,
		rows: [],
		incidenceModal: {
			show: false,
			info: null,
		},
	}),
	computed: {
		title() {
			return `Hijos de ${this.specimen.plate} ${this.specimen.alias ? "/" : ""} ${
				this.specimen.alias ? this.specimen.alias : ""
			} con incidencias`
		},
		fields() {
			return [
				{ key: "specimen", label: "EJEMPLAR", class: "text-center" },
				{ key: "partner", label: `${this.category_id == 1 ? "Madrilla" : "Padrillo"}`, class: "text-center" },
				{ key: "total_incidences", label: "Incidencias", class: "text-center" },
				{ key: "action", label: "Acción", class: "text-center" },
			]
		},
		totalSons() {
			return this.rows.length
		},
		totalIncidences() {
			return this.rows.reduce((acc, row) => acc + row.total_incidences, 0)
		},
		average() {
			return this.totalSons > 0 ? (this.totalIncidences / this.totalSons).toFixed(2) : 0
		},
	},
	methods: {
		openIncidenceModal(item) {
			this.incidenceModal.info = item
			this.incidenceModal.show = true
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		handleCloseModal() {
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await SpecimenService.getTopSonIncidencesReportDetails({
					category_id: this.category_id,
					specimen_id: this.specimen.id,
				})
				this.rows = data || []
			} catch (error) {
				console.error("Error fetching rows in TopSonIncidenceDetails:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.$refs["top-son-incidence-details"].toggle()
		this.getRows()
	},
}
</script>
<style lang="scss" scoped>
.incidence-badge {
	min-width: 2.5rem;
	padding: 0.35rem 0.65rem;
	font-weight: 600;
	font-size: 0.85rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	transition: all 0.2s;

	&:hover {
		transform: scale(1.1);
	}
}

.custom-card {
	border: 3px solid var(--primary);
	border-radius: 15px;
	transition: all 0.3s ease;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	background: linear-gradient(to bottom, #ffffff, #f8f9fa);

	/* Mejora el diseño interno */
	text-align: center;

	/* Efecto hover sutil */
	&:hover {
		transform: translateY(-3px);
		box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
	}

	/* Estilo para el título h4 */
	h4 {
		color: #6c757d;
		font-size: 1rem;
		font-weight: 600;
		margin-bottom: 0.5rem;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	/* Estilo para el valor h2 */
	h2 {
		color: var(--primary);
		font-size: 2rem;
		margin-bottom: 0;
	}
}
.incidences-counter {
	position: absolute;
	top: -1rem;
	left: 6rem;
	height: 1.2rem;
	max-width: 1.2rem;
	color: #fff;
	display: flex !important;
	align-items: center;
	justify-content: center;
	padding: 2px;
	background: var(--primary);
	border-radius: 0.2rem;
	font-weight: bolder;
	font-size: 12px;
}
.icon-disabled {
	pointer-events: none;
	opacity: 0.5;
}
</style>
